import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';

@Component({
  selector: 'asigned-vs-solved',
  templateUrl: './asigned-vs-solved.component.html',
  styleUrls: ['./asigned-vs-solved.component.scss'],
})
export class AsignedVsSolvedComponent implements OnInit, AfterViewInit {
  constructor(public resumeService: ResumeService) {}
  selected: string = 'Diario';
  @ViewChild('assignedVsSolvedContentLine') assignedVsSolvedContentLine;
  @ViewChild('assignedVsSolvedContent') assignedVsSolvedContent;
  ngOnInit() {
    this.getWeek();
  }
  ngAfterViewInit() {
    // Ensure the canvas is available after view initialization
    this.initChart();
  }

  week;
  month;
  year;
  async getDataAssignedVsResolved() {
    return new Promise((resolve, reject) => {
      this.resumeService.getDataAssignedVsResolved().subscribe(
        (res: any) => {
          this.week = res.week;
          this.month = res.month;
          this.year = res.year;

          resolve();
        },
        (error) => reject(error)
      );
    });
  }

  async getWeek() {
    await this.getDataAssignedVsResolved();
    this.barsData(this.week);
  }

  async getMonth() {
    await this.getDataAssignedVsResolved();
    this.barsData(this.month);
  }

  async getYear() {
    await this.getDataAssignedVsResolved();
    this.barsData(this.year);
  }

  bar: Chart;
  initChart() {
    if (this.assignedVsSolvedContent && this.assignedVsSolvedContentLine) {
      this.assignedVsSolvedContent.nativeElement.width =
        this.assignedVsSolvedContentLine.nativeElement.offsetWidth;
      this.assignedVsSolvedContent.nativeElement.height = '300px';
    } else {
      console.error('Canvas or container element not found.');
    }
  }
  barsData(data: any) {
    if (this.bar) {
      this.bar.destroy();
    }
    // var canvas = document.getElementById(
    //   'bar'
    // ) as HTMLCanvasElement;
    // var parent = document.getElementById('assignedVsSolvedContentLine');

    const canvas = this.assignedVsSolvedContent.nativeElement;

    this.bar = new Chart(canvas.getContext('2d'), {
      type: 'bar',
      data: {
        labels: data.label,
        datasets: [
          {
            label: 'Asignadas',
            data: data.initial,
            backgroundColor: '#24CAA2',
            borderWidth: 1,
            lineTension: 0,
            fill: false,
          },
          {
            label: 'Solucionadas',
            data: data.toFinalize,
            backgroundColor: '#356975',
            borderWidth: 1,
            fill: false,
            lineTension: 0,
          },
        ],
      },
      options: {
        elements: {},
        responsive: true,
        plugins: {
          legend: {
            position: 'right',
          },
          title: {
            display: true,
            text: 'Chart.js Horizontal Bar Chart',
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false, // Remove vertical grid lines
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                drawBorder: false, // Remove horizontal grid border
                display: true, // Keep horizontal lines
              },
              ticks: {
                beginAtZero: true,
                min: 0, // Y axis always starts at 0
                precision: 0, // Integer ticks only (ignored if stepSize is set)
              },
            },
          ],
        },
        tooltips: {
          enabled: false,
          custom: function (tooltipModel) {
            var tooltipEl = document.getElementById('chartjs-tooltip');
            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip';
              tooltipEl.className = 'chartjs-tooltip'; // Ensure class is added
              tooltipEl.innerHTML = '<table></table>';
              document.body.appendChild(tooltipEl);
            }

            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = '0';
              return;
            }

            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
              tooltipEl.classList.add('no-transform');
            }

            function getBody(bodyItem) {
              return bodyItem.lines;
            }

            if (tooltipModel.body) {
              var titleLines = tooltipModel.title || [];
              var bodyLines = tooltipModel.body.map(getBody);

              var innerHtml = '<thead>';
              titleLines.forEach(function (title) {
                innerHtml += '<tr><th>' + title + '</th></tr>';
              });
              innerHtml += '</thead><tbody>';

              bodyLines.forEach(function (body, i) {
                var colors = tooltipModel.labelColors[i];
                var style = 'background:' + colors.backgroundColor;
                style += '; border-color:' + colors.borderColor;
                style += '; border-width: 2px';
                var span = '<span style="' + style + '"></span>';
                innerHtml += '<tr><td>' + span + body + '</td></tr>';
              });
              innerHtml += '</tbody>';

              var tableRoot = tooltipEl.querySelector('table');
              tableRoot.innerHTML = innerHtml;
            }

            var position = this._chart.canvas.getBoundingClientRect();

            // Apply styles
            tooltipEl.style.opacity = '1';
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.left =
              position.left + window.pageXOffset + tooltipModel.caretX + 'px';
            tooltipEl.style.top =
              position.top + window.pageYOffset + tooltipModel.caretY + 'px';
            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
            tooltipEl.style.padding =
              tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.zIndex = '9999'; // Ensure tooltip is on top

            // Inline style fallback for visibility
            tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
            tooltipEl.style.borderRadius = '3px';
            tooltipEl.style.color = 'white';
            tooltipEl.style.padding = '10px';
          },
        },
      },
    });
  }
}
